
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Lizenz`}</h1>
    <p>{`Falls du den Spielrahmen für ein eigenes Rätselspiel verwenden möchtest, schreib
bitte an `}<a parentName="p" {...{
        "href": "mailto:lilli.anders@online.de"
      }}>{`lilli.anders@online.de`}</a>{`.`}</p>
    <h2>{`Bilder`}</h2>
    <p>{`Alle Bilder stammen von Pixabay, Pexels oder Unsplash. Wir danken den
Fotografen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;